import React, { Component } from 'react';
import './ErrorScreen.css';
import { BsExclamationTriangle } from 'react-icons/bs';
import { withTranslation } from "react-i18next";

class ErrorScreen extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="ErrorScreen">
                <BsExclamationTriangle className="ErrorScreenIcon" />
                <h1>{this.props.header}</h1>
                <p>{t(this.props.text)}</p>
                <p>{t(this.props.bottomText)}</p>
                <p><a href="mailto:photovalidation@igoriatrade.com">photovalidation@igoriatrade.com</a></p>
                <p>{t('Możesz również napisać na czacie, chętnie pomożemy')}</p>
            </div>
        );
    }
}

export default withTranslation()(ErrorScreen);
